<template>
  <header class="app-header">
    <div class="header-left">
      <!-- Mobile Menu Button -->
      <button class="mobile-menu-btn" @click="$emit('toggle-mobile-menu')">
        <span class="material-symbols-outlined">menu</span>
      </button>

      <!-- Dashboard Title -->
      <div class="dashboard-title">
        <h1>{{ title }}</h1>
      </div>
    </div>

    <!-- Search Bar (Desktop) -->
    <div class="search-container">
      <div class="search-field">
        <span class="material-symbols-outlined search-icon">search</span>
        <input
          type="text"
          placeholder="Suche..."
          v-model="searchQuery"
          class="search-input"
        />
      </div>
      <div class="search-underline"></div>
    </div>

    <!-- Right Side Controls -->
    <div class="header-right">
      <!-- Mobile Search Button -->
      <button class="mobile-search-btn">
        <span class="material-symbols-outlined">search</span>
      </button>

      <!-- Notifications -->
      <div class="notification-container" @click="showNotifications">
        <span class="material-symbols-outlined notification-icon">notifications</span>
        <div class="notification-badge"></div>
      </div>

      <!-- User Profile -->
      <div class="user-profile" @click="toggleUserMenu" v-click-outside="closeUserMenu">
        <!-- Desktop User Info -->
        <div class="user-info">
          <div class="user-name">{{ userDisplayName }}</div>
          <div class="user-role">{{ userDisplayType }}</div>
        </div>

        <!-- User Avatar -->
        <!-- <div class="user-avatar"></div> -->
<span class="user-avatar material-symbols-outlined ">account_circle</span>
        <!-- Settings Icon -->
        <!-- <div class="settings-icon">
          <svg class="settings-svg" fill="none" preserveAspectRatio="none" viewBox="0 0 17 17">
            <path d="M8.11328 0.5C8.68075 0.5 9.24068 0.558785 9.78613 0.674805L10.1523 2.68164C10.3011 3.4965 11.0826 4.03631 11.8975 3.8877C11.9775 3.8731 12.0563 3.85252 12.1328 3.8252L14.0518 3.13867C14.8075 3.97519 15.3802 4.96186 15.7275 6.03613L14.1719 7.35645C13.5405 7.89267 13.4638 8.83925 14 9.4707C14.0527 9.53274 14.1098 9.59087 14.1719 9.64355L15.7275 10.9639C15.3802 12.0381 14.8075 13.0248 14.0518 13.8613L12.1328 13.1748C11.3528 12.8963 10.4946 13.303 10.2158 14.083C10.1884 14.1596 10.167 14.2383 10.1523 14.3184L9.78613 16.3252C9.24068 16.4412 8.68075 16.5 8.11328 16.5C7.54551 16.5 6.98517 16.4404 6.43945 16.3242L6.07422 14.3184C5.92547 13.5037 5.14482 12.9639 4.33008 13.1123C4.24995 13.1269 4.17039 13.1474 4.09375 13.1748L2.17578 13.8613C1.42006 13.0248 0.84739 12.0381 0.5 10.9639L2.05469 9.64355C2.68611 9.1074 2.76358 8.16078 2.22754 7.5293C2.17482 7.46721 2.11677 7.40916 2.05469 7.35645L0.5 6.03613C0.84739 4.96189 1.42006 3.97517 2.17578 3.13867L4.09375 3.8252C4.87386 4.10397 5.73294 3.6971 6.01172 2.91699C6.03907 2.84043 6.05963 2.76158 6.07422 2.68164L6.43945 0.675781C6.98517 0.559622 7.54551 0.500018 8.11328 0.5ZM8.11328 6C6.73269 6.00014 5.61328 7.11937 5.61328 8.5C5.61328 9.88063 6.73269 10.9999 8.11328 11C9.49399 11 10.6133 9.88071 10.6133 8.5C10.6133 7.11929 9.49399 6 8.11328 6Z" stroke="currentColor"></path>
          </svg>
        </div> -->

        <!-- Mobile Avatar Only -->
        <!-- <div class="mobile-avatar"></div> -->
        <span class="mobile-avatar material-symbols-outlined">account_circle</span>

        <!-- User Dropdown Menu -->
        <div class="user-dropdown" v-show="showUserDropdown">
          <div class="dropdown-header">
            <!-- <div class="dropdown-avatar"></div> -->
            <span class="material-symbols-outlined dropdown-avatar">account_circle</span>
            <div class="dropdown-user-info">
              <div class="dropdown-user-name">{{ userDisplayName }}</div>
              <div class="dropdown-user-role">{{ userDisplayType }}</div>
            </div>
          </div>

          <hr class="dropdown-divider">

          <div class="dropdown-menu-item" @click="$emit('show-language-dialog')">
            <span class="material-symbols-outlined">public</span>
            <span>{{ lang.A0006 }} ({{ languageList ? languageList[globals.selectedLanguage] : '' }})</span>
          </div>
          <div class="dropdown-menu-item" @click="navigate('/settings', lang.A0024)">
            <span class="material-symbols-outlined">settings</span>
            <span>{{ lang.A0024 }}</span>
          </div>
          <hr class="dropdown-divider">
          <div class="dropdown-menu-item" @click="$emit('user-logout')">
            <span class="material-symbols-outlined">logout</span>
            <span>{{ lang.A0003 }}</span>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
// import AuthenticationService from "@/services/AuthenticationService";

export default {
  name: 'AppHeaderAlternative',
  props: {
    title: { type: String, default: 'Dashboard' },
    lang: { type: Object, required: true },
    languageList: { type: Object, required: true },
  },
  data() {
    return {
      searchQuery: '',
      showUserDropdown: false
    }
  },
  methods: {
    navigate(route, title) {
      this.$router.push(route);
      this.$emit('set-title', title);
    },

    showNotifications() {
      // Handle notifications click
    },
    toggleUserMenu() {
      this.showUserDropdown = !this.showUserDropdown;
    },
    closeUserMenu() {
      this.showUserDropdown = false;
    },
    logout() {
      // Handle logout logic
      this.showUserDropdown = false;
      // Add your logout logic here
      console.log('Logging out...');
    }
  },
  directives: {
    'click-outside': {
      bind(el, binding) {
        el.clickOutsideEvent = function(event) {
          if (!(el === event.target || el.contains(event.target))) {
            binding.value();
          }
        };
        document.addEventListener('click', el.clickOutsideEvent);
      },
      unbind(el) {
        document.removeEventListener('click', el.clickOutsideEvent);
      }
    }
  },
  computed: {
    localUserProfile() {
      return this.globals.currentUserInfo;
    },

    userDisplayName: function() {
      if (!this.localUserProfile)
        return;

      if (this.localUserProfile && this.localUserProfile.FirstName && this.localUserProfile.LastName)
        return `${this.localUserProfile.FirstName} ${this.localUserProfile.LastName}`;
      else
        return this.localUserProfile.LoginName;
    },

    userDisplayType: function() {
      if (!this.localUserProfile)
        return;

      if (this.localUserProfile.UserType)
        return this.localUserProfile.UserType === 'M' ? 'Admin' : 'User';
      return 'User';
    },

    userInitials: function() {
      if (!this.localUserProfile)
        return;

      if (this.localUserProfile.FirstName && this.localUserProfile.LastName)
        return this.localUserProfile.FirstName.charAt(0).toUpperCase() + this.localUserProfile.LastName.charAt(0).toUpperCase();
      else
        return this.localUserProfile.LoginName.charAt(0).toUpperCase() + this.localUserProfile.LoginName.charAt(1).toUpperCase();
    },

  }
}
</script>

<style lang="css" scoped>
.app-header {
  background-color: #ffffff;
  display: flex;
  height: 144px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border-bottom: 1px solid #e0e0e0;
  position: sticky;
  top: 0;
  z-index: 10;
  transition: all 0.3s;

  @media (min-width: 1024px) {
    padding: 38.5px 24px;
  }
}

.header-left {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
}

.mobile-menu-btn {
  display: block;
  padding: 8px;
  color: #252424;
  background: none;
  border: none;
  cursor: pointer;
  transition: color 0.2s;

  &:hover {
    color: #f50537;
  }
/*
  @media (min-width: 1024px) {
    display: none;
  } */

  .material-symbols-outlined {
    font-size: 16px;
  }
}

.dashboard-title {
  h1 {
    font-weight: 600;
    color: #252424;
    font-size: 20px;
    line-height: 28px;
    white-space: nowrap;
    margin: 0;
    transition: all 0.3s;

    @media (min-width: 640px) {
      font-size: 28px;
      line-height: 40px;
    }

    @media (min-width: 1024px) {
      font-size: 28px;
      line-height: 68px;
    }
  }
}

.search-container {
  display: none;
  flex-direction: column;
  align-items: flex-start;
  width: 400px;
  transition: all 0.3s;

  @media (min-width: 1024px) {
    display: flex;
  }

  @media (min-width: 1280px) {
    width: 500px;
  }

  &:hover .search-underline > div,
  &:focus-within .search-underline > div {
    background-color: #f50537;
  }
}

.search-field {
  display: flex;
  flex-direction: row;
  gap: 12px;
  height: 36px;
  align-items: flex-start;
  overflow: hidden;
  padding: 4px 0 8px 0;
  width: 100%;

  .search-icon {
    font-size: 24px;
    color: #666666;
  }
}

.search-input {
  width: 100%;
  background: transparent;
  color: #333333;
  font-size: 16px;
  letter-spacing: 0.0032px;
  line-height: 24px;
  border: none;
  border-bottom: 1px solid #333333;
  outline: none;
  transition: colors 0.2s;

  &::placeholder {
    color: #888888;
  }
}

.search-underline {
  height: 1px;
  width: 100%;
  transition: colors 0.2s;

  > div {
    width: 100%;
    height: 100%;
    background-color: #666666;
    transition: background-color 0.2s;
  }
}

.header-right {
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
  justify-content: flex-end;

  @media (min-width: 1024px) {
    gap: 24px;
  }
}

.mobile-search-btn {
  display: block;
  padding: 8px;
  color: #252424;
  background: none;
  border: none;
  cursor: pointer;
  transition: color 0.2s;

  &:hover {
    color: #f50537;
  }

  @media (min-width: 1024px) {
    display: none;
  }

  .material-symbols-outlined {
    font-size: 16px;
  }
}

.notification-container {
  position: relative;
  width: 42px;
  height: 42px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s;

  &:hover {
    transform: scale(1.05);
  }

  .notification-icon {
    font-size: 24px;
    color: #252424;
    transition: color 0.2s;

    &:hover {
      color: #f50537;
    }
  }

  .notification-badge {
    position: absolute;
    top: 4px;
    right: 4px;
    width: 16px;
    height: 16px;
    background-color: #f50537;
    border: 2px solid white;
    border-radius: 50%;
  }
}
.user-profile {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  cursor: pointer;
}





.user-info {
  display: none;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  height: 56px;
  white-space: nowrap;

  @media (min-width: 1024px) {
    display: flex;
  }

  .user-name {
    font-weight: 600;
    color: #252424;
    font-size: 16px;
    line-height: 24px;
    text-align: right;
    transition: color 0.2s;
  }

  .user-role {
    color: #606060;
    font-size: 12px;
    line-height: 20px;
    text-align: center;
    letter-spacing: 0.0024px;
    transition: color 0.2s;
  }
}

.user-avatar {
    display: none !important;
    font-size: 42px;
    color: #252424;
  /* display: none;
  background-image: url('/_assets/v10/50210ef4f0c7a99345ecbd7b6946c51ad23f24a8.png'); */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 43.793px;
  width: 42px;
  height: 42px;
  border: 2px solid transparent;
  transition: all 0.2s;

  @media (min-width: 1024px) {
    display: block !important;
       /* display: inline-flex; */
  }
}

.mobile-avatar {
  display: none !important;
  font-size: 32px;
  color: #252424;

  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    border: 2px solid green;
  }

  @media (max-width: 1024px) {
    display: inline-flex !important;
  }
}


.settings-icon {
  display: none;
  height: 17px;
  width: 16.227px;
  color: #252424;
  transition: color 0.2s;

  @media (min-width: 1024px) {
    display: block;
  }

  .settings-svg {
    width: 100%;
    height: 100%;
  }
}

/* // User Dropdown Menu Styles */
.user-dropdown {
  position: absolute;
      top: -12px;
  /* top: 100%; */
  right: 0;
  /* margin-top: 8px; */
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 0px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 280px;
  z-index: 1000;
  animation: fadeInDown 0.2s ease-out;
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.dropdown-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
}

.dropdown-avatar {
  background-image: url('/_assets/v10/50210ef4f0c7a99345ecbd7b6946c51ad23f24a8.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 50%;
  width: 48px;
  height: 48px;
      color: #252424;
      font-size: 48px;
  flex-shrink: 0;
}

.dropdown-user-info {
  flex: 1;
}

.dropdown-user-name {
  font-weight: 600;
  color: #252424;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 2px;
}

.dropdown-user-role {
  color: #606060;
  font-size: 14px;
  line-height: 20px;
}

.dropdown-divider {
  border: none;
  border-top: 1px solid #e0e0e0;
  margin: 0;
}

.dropdown-menu-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  cursor: pointer;
  transition: background-color 0.2s;
  color: #252424;

  &:hover {
    background-color: #f5f5f5;
  }

  &:first-of-type {
    border-radius: 0 0 8px 8px;
  }

  .material-symbols-outlined {
    font-size: 20px;
    color: #666666;
  }

  span:last-child {
    font-size: 14px;
    font-weight: 500;
  }
}

.material-symbols-outlined {
  font-variation-settings: "FILL" 0, "wght" 400, "GRAD" 0, "opsz" 20;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// AppHeaderAlternative.vue?0f9e3e30